import { Injectable } from '@angular/core';
import {
  InsufficientMilesIconType,
  PopupSettingService,
} from '@rd/popup/services/popup-setting/popup-setting.service';

@Injectable({
  providedIn: 'root',
})
export class AnzPopupSettingService extends PopupSettingService {
  insufficientMilesIconType: InsufficientMilesIconType = 'warning';
}
